// themes/predefinedThemes.ts
import { Theme } from '../types/theme';

export const predefinedThemes: Record<string, Theme> = {
    'modern-light': {
        backgroundColor: '#f8fafc', // Very light gray-blue
        textColor: '#1e293b', // Dark slate
        topbarBackgroundColor: '#ffffff', // Clean white
        topbarIconColor: '#475569', // Medium slate
        topbarBorderBottomColor: '#e2e8f0', // Light gray border
        sidebarBackgroundColor: '#ffffff', // Clean white
        sidebarIconColor: '#c0ccdd', // Slate gray
        sidebarIconColorSelected: '#194e8f', // Modern blue
        sidebarTextColor: '#374151', // Dark gray
        sidebarBorderColor: '#e5e7eb', // Light border
        cardColor: '#ffffff', // Pure white cards
        borderColor: '#e5e7eb', // Consistent light border
        categoryIndicatorColor: '#194e8f', // Modern blue accent
        cartBackgroundColor: '#f2f2f2', // Very light gray
        cartCardColor: '#ffffff', // White cart cards
        cartTextColor: '#111827', // Very dark gray
        cartButtonColor: '#194e8f', // Blue CTA buttons
        cartButtonTextColor: '#ffffff', // White text
        cartSummaryBorder: '#d1d5db', // Medium light border
        payButtonColor: '#194e8f', // Success green
        payButtonTextColor: '#ffffff', // White text
        loaderColor: '#194e8f', // Blue loader
        searchBarColor: '#ffffff'
    },
    'modern-dark': {
        "backgroundColor": "#0a0a0a",
        "textColor": "#f1f5f9",
        "topbarBackgroundColor": "#1a1a1a",
        "topbarIconColor": "#f1f5f9",
        "topbarBorderBottomColor": "#2a2a2a",
        "sidebarBackgroundColor": "#1a1a1a",
        "sidebarIconColor": "#9ca3af",
        "sidebarIconColorSelected": "#194e8f",
        "sidebarTextColor": "#e5e7eb",
        "sidebarBorderColor": "#2a2a2a",
        "cardColor": "#242323",
        "borderColor": "#2a2a2a",
        "categoryIndicatorColor": "#050505ff",
        "cartBackgroundColor": "#0a0a0a",
        "cartCardColor": "#242323",
        "cartTextColor": "#f1f5f9",
        "cartButtonColor": "#194e8f",
        "cartButtonTextColor": "#ffffff",
        "cartSummaryBorder": "#3a3a3a",
        "payButtonColor": "#194e8f",
        "payButtonTextColor": "#ffffff",
        "loaderColor": "#194e8f",
        "searchBarColor": "#1a1a1a"
    },
    'turquoise-orange': {
        backgroundColor: '#f5feff',
        textColor: '#2c2c2c',
        topbarBackgroundColor: '#007a7a',
        topbarIconColor: '#ffffff',
        topbarBorderBottomColor: '#007a7a',
        sidebarBackgroundColor: '#f5feff',
        sidebarIconColor: '#004d4d',
        sidebarIconColorSelected: '#ff7f3f',
        sidebarTextColor: '#004d4d',
        sidebarBorderColor: '#bce5e7',
        cardColor: '#eafafc',
        borderColor: '#bce5e7',
        categoryIndicatorColor: '#ff7f3f',
        cartBackgroundColor: '#dff3f4',
        cartCardColor: '#ffffff',
        cartTextColor: '#2c2c2c',
        cartButtonColor: '#ff7f3f',
        cartButtonTextColor: '#ffffff',
        cartSummaryBorder: '#bce5e7',
        payButtonColor: '#007a7a',
        payButtonTextColor: '#ffffff',
        loaderColor: '#ff7f3f',
        menuButtons: true,
        searchBarColor: '#ffffff'
    },
    white: {
        backgroundColor: 'rgba(243,244,246)',
        textColor: 'navyblue',
        topbarBackgroundColor: 'white',
        topbarIconColor: 'black',
        topbarBorderBottomColor: 'rgba(243,244,246)',
        sidebarBackgroundColor: '#efe8dd',
        sidebarIconColor: '#4a4a4a',
        sidebarIconColorSelected: '#3b5998',
        sidebarTextColor: '#3a3a3a',
        sidebarBorderColor: '#d0c8ba',
        cardColor: '#f7f3e9',
        borderColor: '#c9c1b3',
        categoryIndicatorColor: '#3b5998',
        cartBackgroundColor: '#efe8dd',
        cartCardColor: '#f7f3e9',
        cartTextColor: '#2e2e2e',
        cartButtonColor: '#3b5998',
        cartButtonTextColor: '#ffffff',
        cartSummaryBorder: '#d0c8ba',
        payButtonColor: '#121b26',
        payButtonTextColor: '#ffffff',
        loaderColor: '#3b5998',
        menuButtons: true
    },
    light: {
        backgroundColor: '#f7f3e9',
        textColor: '#2b2b2b',
        topbarBackgroundColor: '#121b26',
        topbarIconColor: '#3a3a3a',
        topbarBorderBottomColor: '',
        sidebarBackgroundColor: '#efe8dd',
        sidebarIconColor: '#4a4a4a',
        sidebarIconColorSelected: '#3b5998',
        sidebarTextColor: '#3a3a3a',
        sidebarBorderColor: '#d0c8ba',
        cardColor: '#f7f3e9',
        borderColor: '#c9c1b3',
        categoryIndicatorColor: '#3b5998',
        cartBackgroundColor: '#efe8dd',
        cartCardColor: '#f7f3e9',
        cartTextColor: '#2e2e2e',
        cartButtonColor: '#3b5998',
        cartButtonTextColor: '#ffffff',
        cartSummaryBorder: '#d0c8ba',
        payButtonColor: '#121b26',
        payButtonTextColor: '#ffffff',
        loaderColor: '#3b5998',
        menuButtons: true
    },
    cream: {
        backgroundColor: '#f7f3e9',
        textColor: '#2b2b2b',
        topbarBackgroundColor: '#121b26',
        topbarIconColor: '#3a3a3a',
        topbarBorderBottomColor: '',
        sidebarBackgroundColor: '#efe8dd',
        sidebarIconColor: '#4a4a4a',
        sidebarIconColorSelected: '#3b5998',
        sidebarTextColor: '#3a3a3a',
        sidebarBorderColor: '#d0c8ba',
        cardColor: '#f7f3e9',
        borderColor: '#c9c1b3',
        categoryIndicatorColor: '#3b5998',
        cartBackgroundColor: '#efe8dd',
        cartCardColor: '#f7f3e9',
        cartTextColor: '#2e2e2e',
        cartButtonColor: '#3b5998',
        cartButtonTextColor: '#ffffff',
        cartSummaryBorder: '#d0c8ba',
        payButtonColor: '#121b26',
        payButtonTextColor: '#ffffff',
        loaderColor: '#3b5998',
        menuButtons: true
    },
    dark: {
        backgroundColor: '#101014',
        textColor: 'white',
        cardColor: '#1b1b21',
        topbarBackgroundColor: '#101014',
        topbarIconColor: 'white',
        topbarBorderBottomColor: '#101014',
        sidebarBackgroundColor: '#101014',
        sidebarIconColor: 'white',
        sidebarIconColorSelected: 'royalblue',
        sidebarTextColor: 'white',
        sidebarBorderColor: '#101014',
        borderColor: '#3b3b3b',
        categoryIndicatorColor: 'royalblue',
        cartBackgroundColor: '#1c1d24',
        cartCardColor: '#323441',
        cartTextColor: 'white',
        cartButtonColor: 'lightgrey',
        cartButtonTextColor: 'black',
        cartSummaryBorder: '#323441',
        payButtonColor: '#323441',
        payButtonTextColor: 'white',
        loaderColor: 'royalblue',
        menuButtons: false
    }
};